import { render, staticRenderFns } from "./ProfileDetailsForm.vue?vue&type=template&id=22f8d603&"
import script from "./ProfileDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProfileDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetailsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports